import React from 'react';
import { Button, Col, Form, Icon, Input, message, Modal, Row, Switch, Tooltip, Upload } from 'antd';

import { API_ENDPOINT } from '../../index';

const { Item } = Form;


class BannerModal extends React.Component {
    render() {
        const { getFieldDecorator } = this.props.form;
        const { banner, loading } = this.state;

        // const { image } = banner;

        if(this.props.banner === null) {
            return (
                <div> Loading... </div>
            )
        }

        return(
            <Modal
                //confirmLoading={this.state.loading}
                title={ this.renderActiveSwitch(banner)}
                onCancel={this.handleCancel}
                footer={[
                    <Button key="cancel" onClick={this.handleCancel}>Cancel</Button>,
                    <Button 
                        key="submit" 
                        type="primary" 
                        loading={loading}
                        onClick={this.handleSubmit}>
                      Submit
                    </Button>,
                  ]}
                visible={this.props.visible}
                >
                
                    {/* active: Boolean,
                    link: String,
                    name: String,
                    position: Number,
                    title: String,
                    src: String, */}
                <Form>
                    <Item 
                        label="Name">
                        {getFieldDecorator('name', {
                            initialValue: banner.name,
                            rules: [
                                { required: true, message: 'Please input the name of this banner'},
                                { type: 'string', message: 'The input is not a valid name'}
                            ]
                        })(
                            <Input/>
                        )}
                    </Item>    

                    <Item 
                        label="Title">
                        {getFieldDecorator('title', {
                            initialValue: banner.title,
                            rules: [
                                { required: true, message: 'Please input the Title'},
                                { type: 'string', message: 'The input is not valid'}
                            ]
                        })(
                            <Input />
                        )} 
                    </Item>  

                    <Item 
                        label="Link">
                        {getFieldDecorator('link', {
                            initialValue: banner.link,
                            rules: [
                                { required: true, message: 'Please input the link'},
                                { type: 'string', message: 'The input is not valid'}
                            ]
                        })(
                            <Input />
                        )} 
                    </Item>

                    <Item 
                        label="Background Color">
                        {getFieldDecorator('color', {
                            initialValue: banner.color,
                            rules: [
                                { required: true, message: 'Please input the color'},
                                { type: 'string', message: 'The input is not valid'}
                            ]
                        })(
                            <Input />
                        )} 
                    </Item>  

                    <Item 
                        label={this.renderTooltip()}>
                        <Row 
                            className="banner-modal-image-box"
                            type="flex" 
                            justify="center"
                        >
                            <Col  >
                                {(banner.image) ?
                                        <img 
                                        alt="banner"
                                        className="banner-modal-image" 
                                        src={`${banner.image.url}`} />
                                        :
                                        <div>No Image</div>
                                }
                            </Col>
                        </Row>
                        
                        {/* {console.log("banner = " , banner)} */}
                        {getFieldDecorator('image', {
                            // initialValue: banner.name,
                            rules: [
                                { required: true, message: 'Please input an image'},
                            ]
                        })(
                            <Row>
                                <Upload
                                    action={`${API_ENDPOINT}/api/upload/banner-images`}
                                    accept='image/*'
                                    beforeUpload={this.beforeUpload}
                                    // fileList={this.state.fileList}
                                    withCredentials={true}
                                    name= 'picture'
                                    onChange={this.handleChangeImage}

                                >
                                    <Button>
                                        <Icon type="upload" /> Upload
                                    </Button>
                                </Upload>
                                 
                            </Row>
                        )}

                    </Item>   


                    <Item 
                        label={this.renderTooltip( "(mobile)" )}>
                        <Row 
                            className="banner-modal-image-box"
                            type="flex" 
                            justify="center"
                        >
                            <Col  >
                                {(banner.mobileImage) ?
                                        <img 
                                            alt="banner"
                                            className="banner-modal-image" 
                                            src={`${banner.mobileImage.url}`} />:
                                        <div>No Image</div>
                                }
                            </Col>
                        </Row>
                        
                        {getFieldDecorator('mobileImage', {
                            // initialValue: banner.name,
                            rules: [
                                { required: true, message: 'Please input an image'},
                            ]
                        })(
                            <Row>
                                <Upload
                                    action={`${API_ENDPOINT}/api/upload/banner-images`}
                                    accept='image/*'
                                    beforeUpload={this.beforeUpload}
                                    // fileList={this.state.fileList}
                                    withCredentials={true}
                                    name= 'picture'
                                    onChange={this.handleChangeMobileImage}

                                >
                                    <Button>
                                        <Icon type="upload" /> Upload
                                    </Button>
                                </Upload>
                                 
                            </Row>
                        )}
                    </Item>

                </Form>
            </Modal>
        )
    }

    renderActiveSwitch = (banner) => {
        return (
            <Row>
                <Col span={19} >
                    Edit 
                </Col>
                {/* {console.log("active = " , banner)} */}
                <Col span={4} >
                    <Switch 
                        checkedChildren="Active" 
                        unCheckedChildren="Inactive"
                        defaultChecked={banner.active}  
                        onChange={this.toggleActive}/>
                </Col>
            </Row>
        )
    }

    constructor(props) {
        super(props);
        this.state = {
            banner: {
                // _id: '',
                active: true,
                link: '',
                name: '',
                // position: null,
                title: '',
                img: null
            },
            fileList: null,
            loading: false,
        }
    }

    componentWillMount() {
        // console.log("on open modal" , this.props.banner)
        this.setState({
            banner: this.props.banner
        })
    }

    beforeUpload = (file) => {
        const isLt2M = file.size / 1024 / 1024 < 0.5;
        if(!isLt2M) {
            message.error('Image must be smaller than 500KB')
        }

        // console.log("file" ,    file)

        return isLt2M;
    }

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    handleCancel = () => {
        setTimeout(() => {
            this.props.handleCancel()
        }, 300)
    }

    handleChangeImage = ( info ) => {
        // console.log("INFO =" , info)
        // console.log(info);
        if(info.file.status === 'done') {
            // this.setState({fileList: info})
            // console.log("DONE")
            const {image} = info.file.response;

            this.getBase64(info.file.originFileObj, data => this.setState({
                banner: {
                    ...this.state.banner,
                    image
                }
            }))
        }


    }

    handleChangeMobileImage = ( info ) => {
        // console.log("INFO =" , info)
        if(info.file.status === 'done') {
            // this.setState({fileList: info})
            // console.log("DONE")
            const {image} = info.file.response;

            this.getBase64(info.file.originFileObj, data => this.setState({
                banner: {
                    ...this.state.banner,
                    mobileImage: image
                }
            }))
        }


    }

    handleSubmit = () => {

        const checkAllFieldsAreFilled = (fieldData) => {
            if(fieldData.name === '' || fieldData.title === '' || fieldData.link === ''
            //data.src===''
            ) return false; 

            return true;
        }

        let _banner = this.props.form.getFieldsValue();

        this.setState({
            banner: {
                ...this.state.banner,
                // _banner
                name: _banner.name,
                title: _banner.title,
                link: _banner.link,
                color: _banner.color
            }
        })
        
        this.setState({
            loading: true
        })

        /*Check if all fields are filled in*/
        
        /* The function <checkAllFieldsAreFilled> is not completed. Does not check
            if img is present yet */

        setTimeout(() => {
            // console.log("modal state  =" , this.state.banner)
            if(checkAllFieldsAreFilled(this.state.banner)) {
                //submit and close 
                this.props.handleSubmit(this.state.banner)
                message.success("Success")
            
            } else {
                message.error("Some fields are not filled up")
                this.setState({loading: false})
            }
        }, 800)
        
    }
    
    renderTooltip = ( type = null ) => {
        return (
            <Tooltip title="Uploaded image will replace existing image">
                Image {type} <Icon className="image-tooltip" type="info-circle-o" />
            </Tooltip>
        )
    }

    toggleActive = () => {
        this.setState({
            banner: {
                ...this.state.banner,
                active: !this.state.banner.active
            }
        })
    }
}

export default Form.create()(BannerModal);


// WEBPACK FOOTER //
// ./src/components/banners/modal.js